export class Estado {
  ativo: boolean;
  id: number;
  nome: string;
  sigla: string;
  codigo: number;
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/enderecos/estados/shared/estado.model.ts
 **/